import { CountryModel } from './CountryModel';

export class LocationDetailsResponse {
  public streetName: string;
  public houseNumber: string;
  public cityName: string;
  public postalCode: string;
  public stateName: string;
  public countryId: number;
  public country: CountryModel;
  /** This field is not in the server side model yet. added when utilized the address component to fit the Unit address format. */
  public street2Name: string;

  public fullAddress: string;
  public googlePlaceId: string;
  public lat: number;
  public lng: number;
}
